export const sum = (a, b) => {
  return a + b;
}
